export default __webpack_public_path__ + "static/media/washupReferralPromotionBanner.8497b9fa.png";